module.exports = __webpack_public_path__ + "static/media/refer-banner-image.2fcb5b69.svg";